var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"assign-exam"}},[_c('vx-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }